import React from 'react';
import { connect } from 'react-redux';

import PageHeader from '../../modules/PageHeader';
import PageMeta from '../../modules/PageMeta';
import SidebarColumn from '../../modules/SidebarColumn';
import PageSidebar from '../../modules/PageSidebar';
import ContentColumn from '../../modules/ContentColumn';
import PageSection from '../../modules/PageSection';
import AlertBox from '../../modules/AlertBox';
import AlertMessage from '../../modules/AlertMessage';
import RegisterForm from '../../forms/Register';
import Page from '../../pages/Page';

import * as registerActions from "../../../actions/register";

class Register extends React.Component {

    constructor() {
        super();

        this.register = this.register.bind(this);
    }

    componentDidMount() {
        this.props.initialiseRegisterForm();
    }

    register(values) {
        return this.props.register(values);
    }

    render() {
        return (
            <Page>
                <PageMeta title="Register" />

                <SidebarColumn>
                    <PageSidebar />
                </SidebarColumn>

                <ContentColumn>
                    <PageHeader>
                        <h1>Register</h1>

                        <span>Register an account for all of your RHE Global services.</span>
                    </PageHeader>

                    <PageSection>
                        <AlertMessage>
                            {this.props.showConfirmation &&
                                <AlertBox theme="success">
                                    Thank you for registering { this.props.registrant.first_name }, you will shortly receive
                                    a request to you confirm your account.
                                </AlertBox>
                            }
                        </AlertMessage>

                        {!this.props.showConfirmation &&

                            <RegisterForm onSubmit={this.register} />
                        }
                    </PageSection>

                </ContentColumn>
            </Page>
        )
    }
}

const mapStateToProps = state => {
    return {
        registrant: state.register.registrant,
        showConfirmation: !!state.register.registrant
    }
};

const mapDispatchToProps = dispatch => {
    return {
        register(params) {
            return dispatch(registerActions.register(params));
        },
        initialiseRegisterForm() {
            dispatch(registerActions.userRegistered(null));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);